import React from "react";
import PropTypes from "prop-types";
import { copyExercises, copyMeal, copyFood } from "../utils/copy-paste-helpers";

export const CopyComponent = ({ 
  className, 
  type = "exercise", // "exercise" | "meal" | "food"
  // Exercise-specific props
  exercises,
  athlete,
  /** Program builder: session.workoutName suffix stored with workout copy */
  workoutNameSuffix,
  /** Section separators to carry through paste (calendar day / program session) */
  sections,
  // Meal-specific props
  meal,
  day,
  query,
  planMode,
  // Food-specific props
  food,
}) => {
  /**
   * Handle copy action based on type
   * @param {*} e
   */
  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (type === "exercise") {
      copyExercises(exercises, athlete, workoutNameSuffix, sections);
    } else if (type === "meal") {
      copyMeal(meal, day, query, planMode);
    } else if (type === "food") {
      copyFood(food, day, query, planMode);
    }
  };

  return (
    <button
      id="button-local-copy"
      className={className}
      onClick={handleCopy}
    >
      <img
        src="/img/new-icons/vuesax-linear-document-copy.svg"
        alt="Copy Icon"
      />
    </button>
  );
};

CopyComponent.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(["exercise", "meal", "food"]),
  // Exercise-specific props
  exercises: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  athlete: PropTypes.object,
  workoutNameSuffix: PropTypes.string,
  sections: PropTypes.array,
  // Meal-specific props
  meal: PropTypes.object,
  day: PropTypes.object,
  query: PropTypes.object,
  planMode: PropTypes.string,
  // Food-specific props
  food: PropTypes.object,
};
